import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  prefix: {
    id: 'components.displayTime.prefix',
    defaultMessage: 'klo {time}',
  },
})
